import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderItem,
  SliderDrag,
  SliderProgress,
  SliderBtn,
  SliderDots,
  SliderCount,
} from '@studiometa/ui';

/**
 * Slider component
 */
export default class Slider extends withBreakpointObserver(SliderCore) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    options: {
      ...SliderCore.config.options,
    },
    components: {
      SliderItem,
      SliderDrag,
      SliderDots,
      SliderBtn,
      SliderProgress,
      SliderCount,
    },
  };
}
